<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-input v-model="getYcAiTrainClassList_data.aaTitle" placeholder="请输入标题" clearable size='small'
                    style="max-width:200px;" />
                <!-- <el-select v-model='getYcAiTrainClassList_data.mtmId' clearable placeholder="请输入分类" size='small'
                    style="max-width:200px;">
                    <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId"
                        :label="item.mtmName" :value="item.mtmId"></el-option>
                </el-select> -->
                <el-button @click="getData" type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if="addYcAiTrainClass" @click=" $form('addYcAiTrainClass')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加智能演练场景分类
                </el-button>
            </el-col>
        </el-row>

        <mytable ref="mytable" :tableColums='tableColums_getYcAiTrainClassList' api='getYcAiTrainClassList::yatcId'
            xupdateapi='updateYcAiTrainClass' :height="H - 165" :tree="{ children: 'children', lazy: lazyLoad }"
            @expand="expand" @hasChildrenChange="hasChildrenChange" @cell-mouse-enter="cellMouseEnter"
            @cell-mouse-leave="cellMouseLeave">
            <icol slot='yatcIcon' :showtooltip='false' img='yatcIcon' />
        </mytable>

        <myform :viewobj='{
            addYcAiTrainClass: ["新增智能演练场景分类", "el-icon-circle-plus"],
            updateYcAiTrainClass: ["修改智能演练场景分类", "el-icon-edit-outline"],
            $succeed$: getYcAiTrainClassList
        }' @closed="$form('updateYcAiTrainClass', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.aaIcon = ''))
            " @confirm='myform'>
            <template v-slot:yatcParentId="{ Myformdata }">
                <el-select v-model='Myformdata.yatcParentId' clearable placeholder="请选择上级分类" style="max-width:200px;">
                    <el-option v-for="(item, index) in getYcAiTrainClassListLevel_data.data || []" :key="index"
                        :label="item.yatcName" :value="item.yatcId"></el-option>
                </el-select>
            </template>
            <template v-slot:yatcIcon='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.yatcIcon+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.yatcIcon = C : false )
                    `' @change='Myformdata.yatcIcon = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.yatcIcon = "")' type='image' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.yatcIcon && Myformdata.yatcIcon != ' '
                        ? ({ name: Myformdata.yatcIcon, url: Myformdata.yatcIcon })
                        : false"
                    :style="{ height: Myformdata.yatcIcon && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
                </myupload>
            </template>
            <hide slot='yatcId' />
        </myform>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mainType: [],
            yatcId: null,
            theyatcId: "",
            getMicrolectureTypeMainList_data: [],
            tableColums_getYcAiTrainClassList: {
                $selection: false,

                yatcName: '分类标题',
                yatcIcon: '图标',
                yatcOrder: '排序',
                createtime: '创建时间',

                $operation: [
                    '操作', 200,
                    this.updateYcAiTrainClass && `@text: 编辑#warn
             @click: $form("updateYcAiTrainClass",$row)
            `,
                    this.deleteYcAiTrainClass && `@text: 删除#danger
             @click: _confirm('确定要删除吗?')
                     .trigger('deleteYcAiTrainClass',{yatcId:$row.yatcId})
                     .trigger('getYcAiTrainClassList')
            `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        hasChildrenChange(value) {
            if (value.children && value.children.length > 0) {
                return (value.hasChildren = true);
            } else {
                return (value.hasChildren = false);
            }
        },
        cellMouseEnter(row, column, cell, event) {
            this.rowShow = row.projectId;
            this.columnShow = column.property;
        },
        cellMouseLeave(row, column, cell, event) {
            this.rowShow = "";
            this.columnShow = "";
        },
        expand(row, expanded) {
            if (row.dtLevel == 1 || row.hasChildren2 === false) return;
            const treeData = this.$refs.mytable.Table.store.states.treeData,
                children = (treeData[row._parent] || 0).children || "";
            if (children.length < 2) return;
            // console.error(row, expanded, row._parent, children, row.hasChildren);
            for (let id of children) {
                if (id !== row.projectId)
                    treeData[id] && (treeData[id].expanded = false);
            }
            return;
        },
        async myform(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
        },
        async sub(submit) {
            this.$nextTick(() => {

            })
            submit();
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData()
        },
        getData() {
            this.getYcAiTrainClassList({
                ...this.getYcAiTrainClassList_data,
                projectId: this.theProjectId
            })
        }
    },

    async created() {
        //   this.getMicrolectureTypeMainLists().result((res) => {
        //     if (res.data.data) {
        //       console.log(res.data.data);
        //       this.getMicrolectureTypeMainList_data = res.data.data
        //     }
        //   })
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcAiTrainClassList();
        this.getYcAiTrainClassListLevel();

    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/AiAgent/AiSceneType.vue